import LoadingAnimatedCard from './LoadingAnimatedCard.jsx';

export default LoadingAnimatedCard;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/LoadingAnimatedCard/index.js